<rask-fieldset-toggle label="Transporthändelse"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-checkbox-list
        label="Transporthändelse"
        [formControlName]="name"
        [items]="options"
        [selected]="form.value.transporthandelse">
    </rask-checkbox-list>
</rask-fieldset-toggle>